import * as Yup from 'yup';

/**
 * Defind default message for fiels base on language
 */
Yup.setLocale({
    mixed: {
        required: "This field cannot be blank"
    },
    // string: {
    //     loginId: "Please enter the correct format for this field'"
    // }
});

export default Yup;